import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    opacity: 0;\n    transition: opacity ", "s ease-in;\n\n    ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            padding-left: ", ";\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            padding: ", "\n                ", ";\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            opacity: 1;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    padding: 0;\n    ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            height: ", "px;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    white-space: normal;\n    background-color: ", ";\n    &:hover td {\n        background-color: ", ";\n    }\n\n    ", ";\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            display: none;\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { makePropList, getPropsBlocker } from '../../../utils';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { TableRow } from '../TableRow';
import { TableCell } from '../TableCell';
import { color, spacing } from '../../../system/mixins';
import { RESIZE_OBSERVER_SUPPORTED } from './constants';
import { transitionDurationInSec } from '../../../constants';
import { componentSpacing04, componentSpacing05 } from '../../../tokens';
var propertyList = makePropList(['expanded', 'height', 'enableDefaultPadding']);

var getRootDynamicStyle = function getRootDynamicStyle(_ref) {
  var expanded = _ref.expanded;
  var result = {};

  if (!expanded) {
    result = css(_templateObject(), result);
  }

  return result;
};

export var TableExpandableSectionRoot = styled(TableRow).withConfig(getPropsBlocker(propertyList, false))(_templateObject2(), color('neutral.00'), color('neutral.00'), getRootDynamicStyle, getComponentOverride('TableExpandableSection'));

var getCellDynamicStyle = function getCellDynamicStyle(_ref2) {
  var height = _ref2.height;
  var result = {};

  if (height >= 0 && RESIZE_OBSERVER_SUPPORTED) {
    result = css(_templateObject3(), result, height);
  }

  return result;
};

export var TableExpandableSectionCell = styled(TableCell).withConfig(getPropsBlocker(propertyList, false))(_templateObject4(), getCellDynamicStyle);

var getContentDynamicStyle = function getContentDynamicStyle(_ref3) {
  var expanded = _ref3.expanded,
      enableDefaultPadding = _ref3.enableDefaultPadding,
      offsetLeft = _ref3.offsetLeft;
  var result = {};

  if (RESIZE_OBSERVER_SUPPORTED) {
    result = css(_templateObject5());
  }

  if (expanded) {
    result = css(_templateObject6(), result);
  }

  if (enableDefaultPadding) {
    result = css(_templateObject7(), result, spacing(componentSpacing05), spacing(componentSpacing04));
  }

  if (offsetLeft !== undefined) {
    result = css(_templateObject8(), result, spacing(offsetLeft));
  }

  return result;
};

export var TableExpandableSectionContent = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject9(), transitionDurationInSec, getContentDynamicStyle);